var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',_vm._g(_vm._b({staticClass:"rounded-pill",attrs:{"color":_vm.chipProps.color,"text-color":_vm.chipProps.textColor,"small":"","label":""}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }